import {
  formEncode,
  getToken,
  handleResponse,
  nextFormDataApi,
  nextJsonApi,
} from '@/API/core';

const insuranceClaims = {
  fetchCompanies: async (data: { company_id?: Number }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/insurance-claim/company',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchLocations: async (
    franchise: string,
    data: { company_id: Number | undefined }
  ) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        `/insurance-claim/location/${franchise}`,
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchInsuranceList: async (data: { company_id: string }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/insurance-claim/insurance',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchRowData: async (data: { company_id: string }, empId?: string) => {
    let response = null;
    const token = await getToken();
    try {
      if (!empId) {
        response = await nextJsonApi.post(
          '/insurance-claim/row-data',
          formEncode(data),
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else
        response = await nextJsonApi.post(
          `/insurance-claim/row-data/${empId}`,
          formEncode(data)
        );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  insertData: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/insurance-claim/insert',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  editData: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/insurance-claim/update',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getData: async (uniqueId: string | null, data: { company_id: string }) => {
    let response = null;
    if (!uniqueId) return null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        `/insurance-claim/data/${uniqueId}`,
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  acceptInsuranceClaim: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/insurance-claim/accept-claim',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  editInsuranceClaim: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/insurance-claim/edit-claim',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  denyInsuranceClaim: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextFormDataApi.post(
        '/insurance-claim/deny-claim',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  deleteInsuranceClaim: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        `/insurance-claim/delete`,
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchPaymentPostedData: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/insurance-claim/payment-posted-data',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchPaymentPostedSummaries: async (data: {
    startDate: string;
    endDate: string;
  }) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/insurance-claim/payment-posted-summary',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updatePaymentPostedData: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/insurance-claim/update-payment-posted-data',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchTaxId: async (franchise: string, data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        `/insurance-claim/${franchise}/tax-id`,
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },

  fetchStoreDetails: async (location: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        `/insurance-claim/store-details/${location}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  fetchPatientData: async (patientId?: string) => {
    let response = null;
    const token = await getToken();
    try {
      let query = `/insurance-claim/patients`;
      response = await nextJsonApi.post(
        query,
        { patientId: patientId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default insuranceClaims;
